import axios from 'axios';

/**
 * 単位マスタ取得
 */
export const getUnitMasterList = () => {
  return axios
    .get(`/api/v1/get/unit_masters`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 単位マスタ並び替え
 */
export const sortUnitMasterItems = (
  // order_listを元に並べ替え
  list_of_ordered_id: any
) => {
  return axios
    .post(
      `/api/v1/unit_masters/update_order`,
      {
        list_of_ordered_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 単位追加
 */
export const createUnitMaster = (name: string) => {
  return axios
    .post(
      `/api/v1/unit_master_items`,
      {
        name
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 単位削除(一斉選択)
 */
export const deleteUnitMasterList = (unit_master_items: any) => {
  return axios
    .post(
      `/api/v1/delete/unit_master_items`,
      {
        unit_master_items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 単位削除(個別)
 */
export const deleteUnitMaster = (id: number) => {
  return axios
    .delete(`/api/v1/unit_masters/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateUnitMasterMemo = (id: number, memo: string) => {
  return axios
    .put(
      `/api/v1/unit_masters/${id}/memo`,
      {
        memo
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
